export default __webpack_public_path__ + "static/media/028-golden gate bridge.be6543a0.svg";